import { useCompanyContext } from '../../../../context/CompanyContext';

const SLChangeOrderReportHeader = () => {
  const { selectedCompany } = useCompanyContext();

  return (
    <div className="blackText printMedia printShow">
      <div className="text-30px text-center mt-5">{selectedCompany!.name}</div>
      <div className="text-28px text-center">SL Change Order</div>
      <div className="ml-3 text-17px mb-5">
        <span className="font-bold mr-1">Created at:</span>
        {new Date().toLocaleString()}
      </div>
    </div>
  );
};

export default SLChangeOrderReportHeader;
